import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {BehaviorSubject, interval, ReplaySubject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Profile} from "../../interface/profile";
import {MatDialogRef} from "@angular/material/dialog";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-login-lock-timer',
  templateUrl: './login-lock-timer.component.html',
  styleUrls: ['./login-lock-timer.component.scss']
})
export class LoginLockTimerComponent implements OnInit {
  private countdownSub?: Subscription;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public countdown$ = new BehaviorSubject<string>(null);
  public showExtendPopup$ = new BehaviorSubject<boolean>(false);
  public sessionExpired$ = new BehaviorSubject<boolean>(false);

  adminControl: FormControl;

  profile: Profile;
  validUntilStr: string = null;


  constructor(
    private _authService: AuthService,
    private dialogRef: MatDialogRef<LoginLockTimerComponent>
  ) {
    this.adminControl = new FormControl( false);
    this._authService.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
        if (profile) {}
        this.validUntilStr = profile.loginLock;
      });
  }

  ngOnInit(): void {
    this.startCountdown();
    this.adminControl.valueChanges.subscribe(value => {
      this.validUntilStr = this.profile.loginLockEnd;
      this.startCountdown();
    });
  }

  startCountdown(): void {
    let validUntilStr = this.validUntilStr;

    validUntilStr = validUntilStr.replace(' ', 'T');


    if (!validUntilStr.endsWith('Z') && !validUntilStr.includes('+')) {
      validUntilStr += 'Z';
    }

    const validUntil = new Date(validUntilStr).getTime();

    this.countdownSub?.unsubscribe();

    this.countdownSub = interval(1).subscribe(() => {
      const now = Date.now();
      const diff = validUntil - now;

      if (diff <= 0 && this.profile.roles[0] !== 'ROLE_ADMIN') {
        this._authService.logout();
      }

      if (diff <= 0) {
        if (this.adminControl.value)
        {
          this.countdown$.next(null);
          this.showExtendPopup$.next(false);
          this.countdownSub?.unsubscribe();
          this.sessionExpired$.next(true);
        } else {
          this.adminControl.setValue(true);
        }
        // this.showExtendPopup$.next(false);
        // this.countdownSub?.unsubscribe();
        // this.sessionExpired$.next(true);

        return;
      }

      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.countdown$.next(
        `${this.pad(minutes)}:${this.pad(seconds)}`
      );
      if (validUntilStr === null ) {
        this.dialogRef.close();
      }
    });
  }

  private pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

}
